import { useQueryClient } from '@tanstack/react-query'
import { LectureVideoUpdateRequest } from '../../../types/video'
import { useApiPostMutation } from '../useApi'

export const useVideosUpdate = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<LectureVideoUpdateRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: LectureVideoUpdateRequest) => {
      try {
        const result = await mutation.mutateAsync({
          url: '/lectures/videos/update',
          data,
        })

        queryClient.invalidateQueries({ queryKey: ['lecture-list'] })
        queryClient.invalidateQueries({ queryKey: ['lecturesStatus'] })
        queryClient.invalidateQueries({ queryKey: ['videosDetail'] })

        return result
      } catch (error) {
        console.error('Video update failed:', error)
        throw error
      }
    },
  }
}
